import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const MessagesApi = {
  sendMessage: async ({ fromUserId, toUserId, messageBody }) => {
    try {
      const response = await axiosInstance.post(Configs.sendMessagesEp, {
        from_user_id: fromUserId,
        to_user_id: toUserId,
        message_body: messageBody,
      });

      return response.data;
    } catch (error) {
      console.error("Failed to send message:", error.message);
      throw new Error("Failed to send message");
    }
  },

  fetchMessages: async ({ userId, tag }) => {
    try {
      const response = await axiosInstance.post(Configs.fetchMessagesEp, {
        user_id: userId,
        tag: tag,
      });

      return response.data;
    } catch (error) {
      console.error("Failed to load messages:", error);
      throw new Error("Failed to load messages");
    }
  },

  // 🔔 Unread messages count
  getUnreadCount: async () => {
    try {
      const response = await axiosInstance.get(Configs.apiGetUnreadCountEp);
      console.log("Unread count response:", response.data);
      return response.data;
      // expected shape:
      // { status: "success", data: { unread_count: number } }
    } catch (error) {
      console.error("Failed to fetch unread count:", error);
      throw new Error("Failed to fetch unread count");
    }
  },
};

export default MessagesApi;
